import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id DF51BF5D-831D-4FD1-8786-498CAC97DBB6
 * name thermometer-high
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-high.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const ThermometerHighIcon = createSvgIcon(<><path d="M15 13V5A3 3 0 0 0 9 5V13A5 5 0 1 0 15 13M12 4A1 1 0 0 1 13 5H11A1 1 0 0 1 12 4Z" /></>, 'ThermometerHighIcon');
export default ThermometerHighIcon